import { ConsumableLifetimeCycleThemeSizeConfig } from './types';

const small: ConsumableLifetimeCycleThemeSizeConfig = {
  consumableLifetimeCycle: {},
};

export default small;
